import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  container: {
    flex: "1 1 100%",
    display: "flex",
    boxShadow: "0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)",
    borderRadius: "10px 10px 0 0",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    height: `calc(100% - 168px)`, //magic number
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0.5em",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
  },
}));
